import React from 'react';

export default function ParentProductIcon({ product = '' }) {
	return <img src={`/assets/img/r/product-${product}-icon.svg`} />;
}
